module.exports = __webpack_public_path__ + "img/j_1.6e2d1ceb.png";